module.exports = __webpack_public_path__ + "static/media/online-shop-banner.24f19e9d.jpg";